import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import VehiclesFilters from './vehicles-filter.component'

import { actions as vehicleActions } from '@cinch/oxd-redux/vehicles/src'
import { getMakesAndModels } from '@cinch/oxd-redux/vehicles/src/selectors'
import { initialValues } from '@cinch/oxd-containers/listing-filters/src'

const mapStateToProps = (state: any) => ({
  makesAndModels: getMakesAndModels(state),
})

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  getFilters: () => dispatch(vehicleActions.getFilters()),
  updateFiltersForm: (make: string, model: string) => {
    const formData = { ...initialValues, make, selectedModel: model }

    dispatch(vehicleActions.updateForm(formData))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(VehiclesFilters)
